import * as React from 'react';

import { Grid } from '@mui/material';

import blitzPhone from '@app/imageAssets/homePage/21_blitz_phone.png';
import bigRunLogo from '@app/imageAssets/homePage/Big_run_logo.png';
import greySquareLogo from '@app/imageAssets/homePage/Grey_Square.png';
import tetherLogo from '@app/imageAssets/homePage/Tether_Studios.png';
import bigRunPhone from '@app/imageAssets/homePage/blackout_bingo_phone.png';
import dgPhone from '@app/imageAssets/homePage/dg_phone.png';
import solCubePhone from '@app/imageAssets/homePage/sol_cube_phone.png';

import { INLINE_VIDEOS } from '../constants';
import { InlineVideoSection } from './index';
import { useIntersectionObserver } from './utils';

function SuccessSection() {
  const { isIntersecting, ref } = useIntersectionObserver();
  const { isIntersecting: isTopPerformingIntersecting, ref: topPerformingRef } =
    useIntersectionObserver();

  return (
    <>
      <Grid
        container={true}
        justifyContent={'center'}
        className={'home-page__success-container max-container'}
      >
        <Grid item={true} xs={10} className="home-page__success-header-box max-screen">
          <div className={`fade-in-section ${isIntersecting ? 'is-visible' : ''}`} ref={ref}>
            <h1 data-qa="home-page__main-title">Success Stories</h1>
          </div>
        </Grid>
        <InlineVideoSection
          videoInfo={INLINE_VIDEOS.tether}
          gridOverride={{
            md: 5,
            lg: 5, // override element default 8
            sx: {
              justifyContent: 'flex-end',
              mb: { xs: 3, md: 0 },
              mr: { md: 1, lg: 2 },
            },
          }}
          wrapperClass="enhanced-video"
        />
        <InlineVideoSection
          videoInfo={INLINE_VIDEOS.bigRun}
          gridOverride={{
            md: 5,
            lg: 5, // override element default 8
            sx: { justifyContent: 'flex-start', ml: { md: 1, lg: 2 } },
          }}
          wrapperClass="enhanced-video"
        />
      </Grid>
      <Grid
        container={true}
        justifyContent={'center'}
        className={'home-page__success-explore-games'}
      >
        <Grid item={true} xs={12} className="home-page__success-explore-games-container">
          <div
            className={`fade-in-section ${isTopPerformingIntersecting ? 'is-visible' : ''}`}
            ref={topPerformingRef}
          >
            <h1 className="home-page__success-explore-games-container-header">
              Top Performing Games on Skillz
            </h1>
          </div>
          <div className="home-page__success-explore-games-container-games-phone-container">
            <div className="home-page__success-game-phone">
              <img src={`${bigRunPhone}`} className="home-page__success-game-phone-image" />
              <h2 className="home-page__success-game-phone-game-name">Blackout Bingo</h2>
              <p className="home-page__success-game-phone-studio-name">Big Run Studios</p>
              <img className="home-page__success-game-phone-studio-logo" src={`${bigRunLogo}`} />
            </div>
            <div className="home-page__success-game-phone">
              <img src={`${solCubePhone}`} className="home-page__success-game-phone-image" />
              <h2 className="home-page__success-game-phone-game-name">Solitaire Cube</h2>
              <p className="home-page__success-game-phone-studio-name">Tether Studios</p>
              <img className="home-page__success-game-phone-studio-logo" src={`${tetherLogo}`} />
            </div>
            <div className="home-page__success-game-phone">
              <img src={`${blitzPhone}`} className="home-page__success-game-phone-image" />
              <h2 className="home-page__success-game-phone-game-name">21 Blitz</h2>
              <p className="home-page__success-game-phone-studio-name">Tether Studios</p>
              <img className="home-page__success-game-phone-studio-logo" src={`${tetherLogo}`} />
            </div>
            <div className="home-page__success-game-phone">
              <img src={`${dgPhone}`} className="home-page__success-game-phone-image" />
              <h2 className="home-page__success-game-phone-game-name">Dominoes Gold</h2>
              <p className="home-page__success-game-phone-studio-name">Grey Square Games</p>
              <img
                className="home-page__success-game-phone-studio-logo"
                src={`${greySquareLogo}`}
              />
            </div>
          </div>
          <a
            href="https://games.skillz.com"
            target="_blank"
            rel="noopener noreferrer"
            className="home-page__success-explore-games-button"
          >
            Explore More Games
          </a>
        </Grid>
      </Grid>
    </>
  );
}

export { SuccessSection };
